import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../context/AccountContext';
import { useToast, VStack } from '@chakra-ui/react';
import ResumesCountChart from './ResumesCountChart';
import axios from 'axios';
import { TARM_AWS_URL } from '../../api/api';
import Loading from '../Loading/Loading';

const DashboardHome = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [seriesData, setSeriesData] = useState([]);
  const [minDate, setMinDate] = useState('');
  const [maxDate, setMaxDate] = useState('');
  const { user } = useContext(AccountContext);
  const toast = useToast();
  const [source] = useState(axios.CancelToken.source());

  useEffect(() => {
    fetchResumesCount();
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, []);


  const fetchResumesCount = async () => {
    try {
      const response = await TARM_AWS_URL.get(`get-resumes-count?author_email=${user.email}`);
      const { minDate, maxDate, all_resumes, unique_resumes } = response.data;

      setMinDate(minDate);
      setMaxDate(maxDate);
      setSeriesData([
        { name: 'All Resumes', data: all_resumes },
        { name: 'Unique Resumes', data: unique_resumes }
      ]);
    } catch (error) {
      console.error(error);
      toast({
        title: 'Error fetching data',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <Loading loading={isLoading} />
  ) : (
    <VStack>
      <ResumesCountChart seriesData={seriesData} minDate={minDate} maxDate={maxDate} />
    </VStack>
  );
};

export default DashboardHome;
